/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

const styles = {
  container: css`
    margin-top: var(--cds-spacing-300);
  `,
};

const TextFeedbackTable = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="rc-TextFeedbackTable" css={styles.container}>
      {children}
    </div>
  );
};

export default TextFeedbackTable;
